import React from "react";
import "./styles.css"

const ProductDetailPolicy = () => {
  return (
    <div className="detailProductPolicy">
      <h1>POLÍTICAS DE PRODUCTO</h1>
      <p>
        1. Precio de mayoreo a partir de 5 productos pudiendo ser estos todos
        diferentes y sin importar el precio unitario ni el importe total <br></br>
        2.
        Variedad de productos desde quemadores hasta potenciadores, desde barras
        energéticas hasta proteínas de carne  <br></br>
        3. Entrega en tu lugar de
        preferencia en no más de 24 horas <br>
        </br>4. Con la filosofía de negocio “si no
        lo tengo lo consigo por y para ti” Por el momento entregamos
        presencialmente en el área metropolitana y parar pedidos en otra ciudad
        se embarca por Estafeta.
      </p>
    </div>
  );
};

export default ProductDetailPolicy;
